import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { map, get, find, uniq } from 'lodash';
import Taxes from '../../main/settings/taxes/Taxes';
import getColumns from '../../main/settings/taxes/components/columns';
import { getShops } from '../../auth/selectors';
import { t } from '../../../modules/infra/i18n';

export default compose(
  connect((state) => ({
    shops: getShops(state),
  })),
  withProps((props) => {
    const columns = getColumns(t);
    return {
      columns: [
        columns.name,
        {
          ...columns.percentage,
          id: 'percentageCalculated',
          accessor: (data) => {
            const { assignments, percentage } = data;
            const percentageVariants = uniq([percentage, ...map(assignments || [], (shop) => shop.percentage)]);
            return percentageVariants.length > 1 ? t('settings:taxes.varies') : get(percentageVariants, '0');
          },
        },
        {
          ...columns.shops,
          id: 'shopsCalculated',
          accessor: (data) => {
            const { shops } = props;
            const { assignments = [] } = data;
            return assignments.length > 1
              ? t('settings:taxes.varies')
              : get(find(shops, ['id', get(assignments, '0.ownerId')]), 'name');
          },
        },
        columns.addToPrice,
        columns.externalOrdersOnly,
        columns.enabled,
      ],
    };
  })
)(Taxes);
